import { Box, Text, styled, IconButton, alpha } from '@ltvco/refresh-lib/theme';

export const PopoverContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '20px',
  padding: '20px 16px',
  maxWidth: '580px',
  boxShadow: `0px 2px 1px -1px ${alpha(
    theme.palette.common.black,
    0.2
  )}, 0px 1px 1px 0px ${alpha(
    theme.palette.common.black,
    0.14
  )}, 0px 1px 3px 0px ${alpha(theme.palette.common.black, 0.12)}`,
}));

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
}));

export const Title = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.text.primary,
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const Description = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

export const OperatorsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const OperatorRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const OperatorSymbolBox = styled(Box)(({ theme }) => ({
  width: '70px',
  minHeight: '40px',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${alpha(theme.palette.common.black, 0.2)}`,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 0',
  flexShrink: 0,
}));

export const OperatorSymbol = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.primary.main,
  textAlign: 'center',
}));

export const OperatorInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));

export const OperatorName = styled(Text)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.primary,
}));

export const OperatorExample = styled(Text)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.secondary,
}));

export const HighlightedText = styled('span')(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.primary.main,
}));

export const OperatorsColumn = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const OperatorsColumnsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2.5),
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));
